import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class ScrollToTopService {
    constructor(router) {
        this.router = router;
    }
    /**
     * Configura el servicio para que detecte los eventos de navegación
     * y realice el scroll al principio de la página
     */
    setupScrollToTop() {
        this.router.events.pipe(
        // Filtra solo eventos de tipo NavigationEnd (cuando se completa la navegación)
        filter(event => event instanceof NavigationEnd)).subscribe(() => {
            // Asegura que la página comience desde arriba
            window.scrollTo(0, 0);
        });
    }
}
ScrollToTopService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScrollToTopService_Factory() { return new ScrollToTopService(i0.ɵɵinject(i1.Router)); }, token: ScrollToTopService, providedIn: "root" });
